import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { string } from 'prop-types';

const Search = ({ className }) => {
    const { colorSystem } = useContext(ThemeContext);

    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}>
            <circle
                cx="7.5"
                cy="7.5"
                r="6.5"
                stroke={colorSystem.primary[1]}
                strokeWidth="2"
            />
            <line
                x1="12.5"
                y1="12.5"
                x2="17.5"
                y2="17.5"
                stroke={colorSystem.primary[1]}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

Search.propTypes = {
    className: string
};

Search.defaultProps = {
    className: ''
};

export default Search;
